import { render } from "./Recommend.vue?vue&type=template&id=02ea7ba8&scoped=true"
import script from "./Recommend.vue?vue&type=script&lang=ts"
export * from "./Recommend.vue?vue&type=script&lang=ts"

import "./Recommend.vue?vue&type=style&index=0&id=02ea7ba8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-02ea7ba8"

export default script